<div class="basket containerBaskBuying" [ngClass]="{'show': count > 0}" (click)="openModal()">
  <mat-icon>shopping_cart</mat-icon>
  <div class="puce">{{count}}</div>
</div>
